import { createSlice } from '@reduxjs/toolkit';

const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    mode: 'dark',
    layoutWidth: 'full', // 'full' or 'constrained'
  },
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    toggleLayoutWidth: (state) => {
      state.layoutWidth = state.layoutWidth === 'full' ? 'constrained' : 'full';
    },
  },
});

export const { toggleTheme, toggleLayoutWidth } = themeSlice.actions;
export default themeSlice.reducer;
